import { render, staticRenderFns } from "./add_subaccountlist.vue?vue&type=template&id=56d5835a&scoped=true&"
import script from "./add_subaccountlist.vue?vue&type=script&lang=js&"
export * from "./add_subaccountlist.vue?vue&type=script&lang=js&"
import style0 from "./add_subaccountlist.vue?vue&type=style&index=0&id=56d5835a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d5835a",
  null
  
)

export default component.exports